import { render, staticRenderFns } from "./invoiceFragment.vue?vue&type=template&id=49a4c270&"
import script from "./invoiceFragment.vue?vue&type=script&lang=js&"
export * from "./invoiceFragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports